// extracted by mini-css-extract-plugin
module.exports = {"container":"HiddenSection_container__J1ysu","comingSoon":"HiddenSection_comingSoon__vGuCk"};